import React from 'react';
import { DialogManager } from '../fasades/dialogmanager';
import { ModelList } from '../fasades/modellist';

export type NewModelInfo = {
    name          : string;
    description   : string;
    rank          : number;
    selectedModel : string;
};

type NewModelProps = {
    input     : NewModelInfo;

    onCancel?  : () => void;
    onSave?    : (data: NewModelInfo) => void;
};

export class NewModelDialog extends React.Component<NewModelProps, NewModelInfo> {
    dialogRef    = React.createRef<HTMLDialogElement>();
    allowedRanks = [2, 4, 8, 16, 32, 64];

    constructor(props: NewModelProps) {
        super(props);
        this.state = props.input;
    }

    componentDidMount() {
        // Show the dialog when the component mounts
        if (this.dialogRef.current) {
          this.dialogRef.current.showModal();
        }
    }

    getRankIndex()
    {
        for (let i = 0; i < this.allowedRanks.length; i++) {
            if (this.allowedRanks[i] === this.state.rank) {
                return i;
            }
        }
        return 0;
    }

    handleCancel()
    {
        if (this.props.onCancel) {
            this.props.onCancel();
        }

        this.handleClose();
    }

    handleClose()
    {
        if (this.dialogRef.current) {
            this.dialogRef.current.close();
        }
        DialogManager.close();
    }

    handleChange(e : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>)
    {
        if (e.target.name === "name") {
            this.setState({ name : e.target.value });
        }
        else if (e.target.name === "description") {
            this.setState({ description : e.target.value });
        }
    }

    handleRankChange(e : React.ChangeEvent<HTMLInputElement>)
    {
        const rankIndex = parseInt(e.target.value, 10);
        this.setState({ rank : this.allowedRanks[rankIndex] });
    }

    handleSelectModel(e : React.ChangeEvent<HTMLSelectElement>)
    {
        this.setState({ selectedModel : e.target.value });
    };

    handleNewModel()
    {
        if (this.props.onSave) {
            this.props.onSave({
                name          : this.state.name,
                description   : this.state.description,
                selectedModel : this.state.selectedModel,
                rank          : this.state.rank
            });
        }

        this.handleClose();
    };

    render() {
        return (
          <dialog ref={this.dialogRef} className="dialogStyle">
            <h2 style={{marginTop: 0}}>New Dialog Model</h2>
            <form method="dialog" onSubmit={e => e.preventDefault()}>
              <label className="labelStyle" htmlFor="name">Name</label>
              <input
                className="inputStyle"
                id="name"
                name="name"
                type="text"
                value={this.state.name}
                onChange={(e) => this.handleChange(e) }
                placeholder="Enter a name"
                required
              />

              <label className="labelStyle" htmlFor="model">Based on</label>
              <select
               className="inputStyle"
               id="model"
               name="selectedModel"
               value={this.state.selectedModel}
               onChange={(e) => this.handleSelectModel(e) }
               required>
              <option value="" disabled>Select a model</option>
              { ModelList.listOfModels!.map(model => (
                <option key={model.name} value={model.id}>{model.name}</option>
               ))}
              </select>

              <label className="labelStyle" htmlFor="description">Description</label>
              <textarea
                className="inputStyle"
                style={{minHeight: '60px', resize: 'vertical'}}
                id="description"
                name="description"
                value={this.state.description}
                onChange={(e) => this.handleChange(e) }
                placeholder="Enter a description"
              />

              <label className="labelStyle" htmlFor="rank">Rank</label>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                <input
                  style={{ flex: 1 }}
                  id="rank"
                  name="rank"
                  type="range"
                  min={0}
                  max={this.allowedRanks.length - 1}
                  step={1}
                  value={this.getRankIndex()}
                  onChange={(e) => this.handleRankChange(e) }
                />
                <span style={{ minWidth: '2.5rem', textAlign: 'center', fontWeight: 'bold' }}>
                {this.state.rank}
                </span>
              </div>

              <div className="buttonRowStyle">
                <button type="button" className="buttonStyle cancelStyle" onClick={() => this.handleCancel()}>
                  Cancel
                </button>
                <button type="button" className="buttonStyle saveStyle" onClick={() => this.handleNewModel()}>
                  Create Model
                </button>
              </div>
            </form>
          </dialog>
        );
      }

    static showDialog() : Promise<NewModelInfo> 
    {
        return new Promise((resolve, reject) => {
            DialogManager.open(
                <NewModelDialog
                    input={{ name: "", description: "", selectedModel : "", rank : 4}}
                    onSave={(data: NewModelInfo) => resolve(data)}
                    onCancel={() => reject(new Error("Cancelled!"))}/>
            );
        });
    }
}

